import React, { useEffect } from 'react';
import FilterComponent from '../children/FilterComponent/FilterComponent';
import { getDataFromUrlToken } from '../../../../utils/urlDataStore';
import { URL_DATA } from '../../../../../config/urlDataConstants';
import { BUTTON_NAME } from './constants';
import { FEEDBACK_360_TYPE_NON_COHORT } from '../../../../../config/questionTypeConstants';
import { deepCopy } from '../../../../utils/deepCopy';
import { Spin } from 'antd';
import { toast } from '../../../../utils/messageUtils';

const BenchmarkReport = (props) => {
    useEffect(() => {
        if (!props.isOrgDetailsFetched) {
            props.fetchOrganizationDataConfigurations({}, (successData) => {
                if (successData && successData.data && successData.data.benchmarkFilters) {
                    props.resetFilterContentsFromSavedData({
                        ...successData.data.benchmarkFilters,
                        date: reStructureDateFormat(successData.data.benchmarkFilters.date)


                    })
                }

            })

        }
        if (!props.isSurveyListFetched) {
            const orgDetails = getDataFromUrlToken(URL_DATA.ORGANIZATION);
            props.fetchSurveysFromTheOrg({ projectTypes: FEEDBACK_360_TYPE_NON_COHORT, size: orgDetails.projectCount + 10 })

        }

    }, [])


    const reStructureDateFormat = (date) => {
        let savedDate = {}
        if (date != null && date.from && date.to) {
            savedDate.customDateRange = [date.from, date.to]
        }
        else {
            savedDate.customDateRange = []
        }
        savedDate.preset = date != null && date.preset ? date.preset : ""
        return savedDate

    }

    const handleSave = () => {
        let payload = deepCopy({ ...props.benchmarkFilters })
        let date = payload.date
        if (date.customDateRange.length > 0) {
            date = { ...date, to: date.customDateRange[1], from: date.customDateRange[0] }
            delete date.preset
        }
        if (date.preset && date.preset != "") {
            delete date.from
            delete date.to
        }
        else {
            delete date.preset
        }
        delete date.customDateRange
        payload.date = date
        props.updateOrganizationDataConfigurations({ benchmarkFilters: payload }, (flag) => {
            if (flag) {
                toast.success("Benchmark report filter saved successfully")

            }
            else {
                toast.error("Failed to save benchmark report filter. Please try again.")

            }
        })
    }

    const onCustomRangeChange = (range, date, dd) => {
        // When both dates are selected, set the custom range and clear any preset
        if (range && range[0] && range[1]) {
            props.handleChangeBenchmarkFilter({ changedItem: { date: { customDateRange: date, preset: "" } }, isFromSaveFilter: true })
        }

        // When cleared (RangePicker X button), reset the custom range and preset
        if (!range) {
            props.handleChangeBenchmarkFilter({ changedItem: { date: { customDateRange: [], preset: "" } }, isFromSaveFilter: true })
        }
    };

    const handleChangeFilterValues = (eventDetails) => {
        props.handleChangeBenchmarkFilter({ changedItem: eventDetails, isFromSaveFilter: true })


    }

    const getTotalProjectCount = () => {
        if (props.fetchSurveyLists.data && props.fetchSurveyLists.data.totalChildProjects) {
            if (props.fetchSurveyLists.data.totalNonCohortProjects) {
                return props.fetchSurveyLists.data.totalChildProjects + props.fetchSurveyLists.data.totalNonCohortProjects
            }
            return props.fetchSurveyLists.data.totalChildProjects
        }
        else return 0
    }

    return (
        <div className='filter-sectionWrapper'>
            <h2>Report</h2>
            <Spin spinning={props.updateOrgConfigurationsApi.isProcessing} tip='Saving filters...'>
            <div className='cardwrapper'>
            <FilterComponent
                        totalCount={getTotalProjectCount()}
                        isError={props.fetchSurveyLists.error || props.fetchOrganizationConfigurationsApi.error}
                        loader={props.fetchSurveyLists.isProcessing || props.fetchOrganizationConfigurationsApi.isProcessing}
                        surveyList={props.fetchSurveyLists.data && props.fetchSurveyLists.data.data ? props.fetchSurveyLists.data.data : []}
                    buttonName={BUTTON_NAME}
                    handleChangeFilterValues={handleChangeFilterValues}
                    dateFields={props.benchmarkFilters.date}
                    surveyField={props.benchmarkFilters.surveys}
                    raterGroups={props.benchmarkFilters.raterGroups}
                    onCustomRangeChange={onCustomRangeChange}
                    surveyNames={props.benchmarkFilters.surveyNames}
                handleApply={handleSave}
            />
        </div>
            </Spin>
        </div>
    );
};

BenchmarkReport.propTypes = {

};

export default BenchmarkReport;